import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** * * Toaster * */

import React, { PureComponent } from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import shortid from 'shortid';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Toast, { LOADING } from '@fil-react-components/toast';
import withStyles from '@fil-react-components/with-styles';
import styles from './Toaster.style';
var Toaster = /*#__PURE__*/function (_PureComponent) {
  _inherits(Toaster, _PureComponent);
  var _super = _createSuper(Toaster);
  function Toaster(props) {
    var _this;
    _classCallCheck(this, Toaster);
    _this = _super.call(this, props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "addToast", function (toastConfig) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
      var _this$props = _this.props,
        _this$props$maxCount = _this$props.maxCount,
        maxCount = _this$props$maxCount === void 0 ? 3 : _this$props$maxCount,
        onAfterAddToast = _this$props.onAfterAddToast;
      var id = options.id || shortid.generate();
      var callback = function callback() {
        return cb(id);
      };
      if (onAfterAddToast) {
        callback = function callback() {
          return onAfterAddToast(id);
        };
      }

      // bail if a toast exists with this ID
      if (!_this.hasToast(id)) {
        // update the toast stack
        _this.setState(function (state) {
          var newToast = _objectSpread(_objectSpread({}, toastConfig), {}, {
            id: id
          }, options);
          var completedToasts = state.toasts.filter(function (toast) {
            return toast.appearance !== LOADING;
          });
          var loadingToasts = state.toasts.filter(function (toast) {
            return toast.appearance === LOADING;
          });
          if (newToast.appearance === LOADING) {
            loadingToasts = [].concat(_toConsumableArray(loadingToasts), [newToast]);
          } else {
            completedToasts = [].concat(_toConsumableArray(completedToasts), [newToast]);
          }
          var sortedToasts = [].concat(_toConsumableArray(completedToasts), _toConsumableArray(loadingToasts));
          if (sortedToasts.length > maxCount) {
            sortedToasts.shift();
          }
          return {
            toasts: sortedToasts
          };
        }, callback);
      }
      return id;
    });
    _defineProperty(_assertThisInitialized(_this), "removeToast", function (e) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var onAfterRemoveToast = _this.props.onAfterRemoveToast;
      var id = get(e, 'currentTarget.dataset.toastId', e);
      var callback = function callback() {
        return cb(id);
      };
      if (onAfterRemoveToast) {
        callback = function callback() {
          return onAfterRemoveToast(id);
        };
      }

      // bail if NO toasts exists with this ID
      if (_this.hasToast(id)) {
        _this.setState(function (state) {
          return {
            toasts: state.toasts.filter(function (t) {
              return t.id !== id;
            })
          };
        }, callback);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hasToast", function (id) {
      var toasts = _this.state.toasts;
      if (!toasts.length) {
        return false;
      }
      return Boolean(toasts.filter(function (t) {
        return t.id === id;
      }).length);
    });
    _this.state = {
      toasts: []
    };
    return _this;
  }
  _createClass(Toaster, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var toasts = this.state.toasts;
      var _this$props2 = this.props,
        placement = _this$props2.placement,
        className = _this$props2.className;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(className, " toaster-container")
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames("toaster-container__toaster toaster-container__toaster--".concat(placement))
      }, toasts.map(function (toast) {
        return /*#__PURE__*/React.createElement(Toast, _extends({
          key: toast.id,
          toastId: toast.id,
          removeToast: _this2.removeToast
        }, toast), toast.content);
      })));
    }
  }]);
  return Toaster;
}(PureComponent);
_defineProperty(Toaster, "defaultProps", {
  maxCount: 3,
  placement: 'default',
  onAfterAddToast: noop,
  onAfterRemoveToast: noop,
  className: ''
});
_defineProperty(Toaster, "propTypes", {
  placement: PropTypes.string,
  maxCount: PropTypes.number,
  onAfterAddToast: PropTypes.func,
  onAfterRemoveToast: PropTypes.func,
  className: PropTypes.string
});
export default withStyles(Toaster, styles);